import { ids } from "@icarros/theme-react";
import styled, { css } from "styled-components";
import { Contrast } from "../../../types/general.types";
import { LinkVariants, LinkWeights } from "./constants";
const { text, color } = ids || {};
const link_1 = (weight, hover) => {
    if (weight === LinkWeights.bold) {
        return hover
            ? { ...text.link.ids_textStyle_body_link_01_bold }
            : { ...text.link.ids_textStyle_body_link_01_xbold };
    }
    return hover
        ? { ...text.link.ids_textStyle_body_link_01_bold }
        : { ...text.link.ids_textStyle_body_link_01_regular };
};
const link_2 = (weight, hover) => {
    if (weight === LinkWeights.bold) {
        return hover
            ? { ...text.link.ids_textStyle_body_link_02_bold }
            : { ...text.link.ids_textStyle_body_link_02_xbold };
    }
    return hover
        ? { ...text.link.ids_textStyle_body_link_02_bold }
        : { ...text.link.ids_textStyle_body_link_02_regular };
};
const link_3 = (weight, hover) => {
    if (weight === LinkWeights.bold) {
        return hover
            ? { ...text.link.ids_textStyle_capition_link_bold }
            : { ...text.link.ids_textStyle_capition_link_xbold };
    }
    return hover
        ? { ...text.link.ids_textStyle_capition_link_bold }
        : { ...text.link.ids_textStyle_capition_link_regular };
};
const base = css `
  color: ${color.text.link.ids_color_text_link_secondary_base};
`;
const baseHover = css `
  color: ${color.text.link.ids_color_text_link_secondary_variant};
`;
const onLight = css `
  color: ${color.contrast.ids_color_contrast_onLight};
`;
const onDark = css `
  color: ${color.contrast.ids_color_contrast_onDark};
`;
const getLinkVariantWeightStyle = (variant, weight, hover) => {
    switch (variant) {
        case LinkVariants.link_1:
            return link_1(weight, hover);
        case LinkVariants.link_2:
            return link_2(weight, hover);
        case LinkVariants.link_3:
            return link_3(weight, hover);
    }
    return;
};
const getLinkContrastStyle = (contrast, hover) => {
    switch (contrast) {
        case Contrast.dark:
            return onDark;
        case Contrast.light:
            return onLight;
        default:
            return hover ? baseHover : base;
    }
};
const StyledLink = styled.a `
  cursor: pointer;
  text-decoration: underline;
  &:link,
  &:visited {
    ${({ contrast }) => getLinkContrastStyle(contrast, false)};
    ${({ variant, weight }) => getLinkVariantWeightStyle(variant, weight, false)};
  }

  &:hover {
    ${({ contrast }) => getLinkContrastStyle(contrast, true)};
    ${({ variant, weight }) => getLinkVariantWeightStyle(variant, weight, true)};
  }
`;
export default StyledLink;
//# sourceMappingURL=Link.style.js.map